import React from "react";
import { FaBolt, FaGift, FaTools, FaTruck } from "react-icons/fa";
import "../pages/Home.css";

const flowSteps = [
  {
    id: "01",
    title: "Instant Booking",
    desc: "Book your mobile repair service online in seconds with our fast and easy booking system.",
    points: ["Quick booking process", "Instant confirmation"],
    icon: FaBolt,
  },
  {
    id: "02",
    title: "Free Pickup",
    desc: "We provide free doorstep pickup for your mobile repair with safe handling and tracking.",
    points: ["Doorstep pickup", "Safe device handling"],
    icon: FaTruck,
  },
  {
    id: "03",
    title: "Expert Repair",
    desc: "Certified technicians repair your mobile using genuine parts and advanced tools.",
    points: ["Genuine parts", "Quality testing"],
    icon: FaTools,
  },
  {
    id: "04",
    title: "Safe Delivery",
    desc: "Your repaired device is safely delivered back with warranty support and invoice.",
    points: ["Secure delivery", "Warranty included"],
    icon: FaGift,
  },
];

const Timeline = () => {
  return (
    <section className="flow-section">
      <div className="flow-container">

        {/* HEADER */}
        <div className="flow-header">

          {/* ✅ SEO HEADING */}
          <h2 className="flow-title">
            How Our <span className="shine">Mobile Repair Service Works</span>
          </h2>

          {/* ✅ SEO DESCRIPTION */}
          <p>
Easy mobile repair process in Bangalore from booking to delivery with doorstep service.          </p>
        </div>

        {/* STEPS */}
        <div className="flow-grid">
          {flowSteps.map((step) => {
            const Icon = step.icon;

            return (
              <div className="flow-card" key={step.id}>
                <div className="flow-card-inner">

                  <div className="flow-title-row">
                    <div className="flow-icon">
                      <Icon />
                    </div>

                    {/* ✅ SEO TITLE */}
                    <h3>{step.title} Service</h3>
                  </div>

                  {/* ✅ SEO DESC */}
                  <p>{step.desc}</p>

                  <div className="flow-tags">
                    {step.points.map((p, i) => (
                      <span key={i} className="flow-tag">
                        <span className="dot"></span> {p}
                      </span>
                    ))}
                  </div>

                </div>

                <div className="big-num">{step.id}</div>
                <div className="glow-border"></div>
              </div>
            );
          })}
        </div>

        {/* ✅ HIDDEN SEO */}
        <div style={{ display: "none" }}>
          mobile repair process, doorstep mobile repair service,
          phone repair booking, mobile pickup repair service,
          fast mobile repair India
        </div>

      </div>
    </section>
  );
};

export default Timeline;